import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { Sidebar } from '../../BulkActionsSidebar'
import {
  BulkUpdateStatusFormModel,
  SubmitCallback,
  ValidationCallback,
} from './typings'
import { FormFields } from './FormFields'
import { useFormActions } from './hooks'

type Props = {
  entityType: ENTITY_TYPES
  validateRows: ValidationCallback
  onSubmit: SubmitCallback
}

export const BulkUpdateStatusForm: React.FC<Props> = (props) => {
  const { entityType, validateRows } = props

  const {
    validate,
    submitHandler,
    salesFunnels,
    salesFunnelStages,
    initSalesFunnel,
  } = useFormActions(props)

  const initialValues: BulkUpdateStatusFormModel = {
    salesFunnelId: initSalesFunnel ? initSalesFunnel.id : '',
    salesFunnelStageId: '',
    closedReason: '',
    customReason: '',
  }

  return (
    <Sidebar
      title="update sales funnel"
      initialValues={initialValues}
      onSubmit={submitHandler}
      validate={validate}
      validateOnBlur={false}
    >
      <FormFields
        entityType={entityType}
        salesFunnels={salesFunnels}
        salesFunnelStages={salesFunnelStages}
        validateRows={validateRows}
      />
    </Sidebar>
  )
}
BulkUpdateStatusForm.displayName = 'BulkUpdateStatusForm'
